// ======================================================
//        createPallet_header
// ======================================================

export const GET_CREATE_PALLET_HEADER = "GET_CREATE_PALLET_HEADER";
export const GET_CREATE_PALLET_HEADER_UPDATE = "GET_CREATE_PALLET_HEADER_UPDATE";
export const COPY_CREATE_PALLET_HEADER = "COPY_CREATE_PALLET_HEADER";

// ======================================================
//        createPallet_lines
// ======================================================

export const GET_CREATE_PALLET_LINES = "GET_CREATE_PALLET_LINES";
export const GET_CREATE_PALLET_LINES_UPDATE = "GET_CREATE_PALLET_LINES_UPDATE";
export const COPY_CREATE_PALLET_LINES = "COPY_CREATE_PALLET_LINES";
export const PALLETNUMS_WITHLINES = "PALLETNUMS_WITHLINES";